import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";

@Component({
	templateUrl: './template_billing_details.component.html'
})
export class TemplateBillingDetailsComponent extends InfoModalComponent {
	details;

	ok() {
		this.close();
	}
}
